import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import Spinner from '../../components/common/Spinner';

import { MembershipStatus } from './MembershipStatus';
import { Overlay } from './Overlay';

import { getMyHubsPowerPack, getMyHubsSummary } from './Portfolio.actions';

import { WalletSummary } from './WalletSummary';

import { Flexed, TabSelectButton, Tabs } from '../../styles/GlobalComponents';
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router';
import {
  MY_HUBS,
  MY_HUBS_AKASHA,
  MY_HUBS_BIG_WHALE,
  MY_HUBS_GAMING,
  MY_HUBS_ORDERS,
  MY_HUBS_PAYMENT,
  MY_HUBS_POWERPACKS,
  MY_HUBS_STAKING,
  MY_HUBS_TRADING
} from '../../routes/routes';
import { Conversion } from './Conversion/Conversion';

import { OrdersSummary } from './Orders/OrdersSummary';
import { PowerPacksSummary } from './PowerPacks/PowerPacksSummary';

export const Portfolio = () => {
  const dispatch = useAppDispatch();

  const { loading, loadingHubs } = useAppSelector((state) => state.portfolio);

  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    dispatch(getMyHubsSummary());
    dispatch(getMyHubsPowerPack());
  }, [dispatch]);

  const pathname = location.pathname;

  if (loading) return <Spinner fullScreen={true} />;

  // const showTabs = () => {
  //   if (
  //     canBuyPowerPacksPackages ||
  //     (!canBuyPowerPacksPackages &&
  //       powerPackPackages?.userPackages?.length !== 0)
  //   ) {
  //     return MY_HUBS_POWERPACKS;
  //   } else if (
  //     canBuyPowerPacksPackages ||
  //     (!canBuyPowerPacksPackages && akashaPackages?.userPackages?.length !== 0)
  //   ) {
  //     return MY_HUBS_AKASHA;
  //   }

  //   return MY_HUBS_BIG_WHALE;
  // };

  return (
    <AnimatedDashboard zoom>
      {/* <WalletSummary /> */}

      <MembershipStatus />

      <Flexed mb='20'>
        <Tabs>
          <TabSelectButton
            onClick={() => history.push(MY_HUBS_POWERPACKS)}
            selected={pathname === MY_HUBS_POWERPACKS}>
            <div>Dr Odin NFTs</div>
          </TabSelectButton>
          <TabSelectButton
            onClick={() => history.push(MY_HUBS_ORDERS)}
            selected={pathname === MY_HUBS_ORDERS}>
            <div>My Orders</div>
          </TabSelectButton>
        </Tabs>
      </Flexed>

      {loadingHubs && <Spinner fullScreen={true} transparent />}

      <Switch location={location} key={location.pathname}>
        <Redirect exact from={MY_HUBS} to={MY_HUBS_POWERPACKS} />
        <Route path={MY_HUBS_POWERPACKS}>
          <PowerPacksSummary />
        </Route>

        <Route path={MY_HUBS_ORDERS}>
          <OrdersSummary />
        </Route>
      </Switch>

      <Conversion pathname={pathname} />

      <Overlay />
    </AnimatedDashboard>
  );
};
